import script from "./Trabajos_Metodologias.vue?vue&type=script&setup=true&lang=js"
export * from "./Trabajos_Metodologias.vue?vue&type=script&setup=true&lang=js"

import "./Trabajos_Metodologias.vue?vue&type=style&index=0&id=530ad472&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-530ad472"]])

export default __exports__